"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalMock = exports.LocalMockDev = void 0;
var local_mock_container_1 = require("./local-mock.container");
Object.defineProperty(exports, "LocalMockDev", { enumerable: true, get: function () { return local_mock_container_1.LocalMockDev; } });
Object.defineProperty(exports, "LocalMock", { enumerable: true, get: function () { return local_mock_container_1.LocalMock; } });
//# sourceMappingURL=index.js.map